class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {

    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    const summaryElement = this.drawer.querySelector('summary');
    summaryElement.click();

    setTimeout(() => {
      setHeaderHeight();
    }, 250);
     
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
myFunction(){
  console.log('333')
  const splideElement4 = document.getElementById("splide2");
 if (splideElement4) {
    var prevButton = document.querySelector('.prev-slide2');
    var nextButton = document.querySelector('.next-slide2');
     console.log( prevButton)
     console.log( nextButton)
    var splideDefaultOptions = {
      type: 'slide',
      rewind: true,
      perPage: 1,
      autoplay: false,
      arrows: true,
      pagination: false,
      drag: true,
      keyboard: true,
      heightRatio: 0.5,
      cover: true,
    };
    
    var splide3 = new Splide(splideElement4, splideDefaultOptions);
    splide3.mount();

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        splide3.go('<');
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        splide3.go('>');
      });
    }
  }
}
  getSectionInnerHTML(html, selector = '.shopify-section') {
      
    setTimeout(() => this.myFunction(), 3000);
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
    myFunction()
  }
}

customElements.define('mini-cart', MiniCart); 

 
